/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { CarpCategoryShowSubCategoryResponse } from './CarpCategoryShowSubCategoryResponse';

export type CarpCategoryShowSubCategoryResponseApiRespoonse = {
    data?: CarpCategoryShowSubCategoryResponse;
    status?: CarpCategoryShowSubCategoryResponseApiRespoonse.status;
    message?: string;
    errors?: Record<string, Array<string>>;
};

export namespace CarpCategoryShowSubCategoryResponseApiRespoonse {

    export enum status {
        SUCCESS = 'success',
        ERROR = 'error',
    }


}

